var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasCustomLoginPage)?_c('div',[_c('PageRenderer',{attrs:{"chimera-options":_vm.loginPageOptions}})],1):_c('div',[_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }